import styled, { css } from 'styled-components';

import { NAV_DESKTOP } from '../../theme/tokens';

/** Page column: sections stack with the source's 12px gap inside the layout slot.
 *  `position: relative` so the "Calibrating" panel (see {@link PulseCalibrating}) can pin
 *  itself over the column. When calibrating, the sections are not rendered and the panel is
 *  the only child, so the column is given a definite height that fills the visible content
 *  card and the absolute panel stretches to it. */
export const PulsePage = styled.div<{ $calibrating?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 2px;

  ${(p) =>
    p.$calibrating &&
    css`
      /* Mobile (<900px) is body-scroll: the content element grows with its content, so
         --content-height would feed back on itself and make the panel indefinitely tall. Use
         the viewport instead, minus the fixed header clearance + a bottom allowance for the
         floating nav, so the panel fills the visible band between them and stays bounded. */
      min-height: calc(100dvh - 200px - env(safe-area-inset-top) - env(safe-area-inset-bottom));

      ${NAV_DESKTOP} {
        /* Desktop: the content area is a FIXED-height internal scroller, so --content-height is
           stable (no feedback). Fill it minus the PageShell Page padding (88+24 top / 36 bottom). */
        min-height: calc(var(--content-height, 100dvh) - 148px);
      }
    `}
`;
